import { CONTENT_PATTERNS, unknownHandlePattern } from './constants';
/**
 * Splits a string by delimiters but retains the delimiters in the result
 * Note: by sorting it in descending order, it ensures that matches that are substrings
 * of another match do not match first
 *
 * @example
 * Text: "Hello @John Smith and @Paul Bunyan"
 * Delimiters: ["@John Smith", "@John", "@Paul Bunyan"]
 * Result: ["Hello", "@John Smith", "and", "@Paul Bunyan"]
 */
export const splitAndRetainDelimiters = (text: string, delimiters: string[]): string[] => {
  if (!text) return [];

  if (!delimiters.length) return [text];

  const sortedDelimiters = [...delimiters].sort((a, b) => b.length - a.length);
  const escapedDelimiters = sortedDelimiters.map((delimiter) => delimiter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

  const patternParts = escapedDelimiters.length ? [...escapedDelimiters, unknownHandlePattern] : [unknownHandlePattern];
  const pattern = new RegExp(`(${patternParts.join('|')})`, 'g');

  return text.split(pattern).filter(Boolean);
};

/**
 * Extracts URLs from a text string
 */
export const extractUrls = (text: string): string[] => {
  const matches = text.match(CONTENT_PATTERNS.URL);
  return matches || [];
};

/**
 * Formats a URL with proper protocol
 */
export const formatUrlWithProtocol = (url: string): string => {
  const urlInLowerCase = url.toLowerCase();
  if (urlInLowerCase.startsWith('http') || urlInLowerCase.startsWith('ftp')) {
    return url;
  }
  return `https://${url}`;
};
